import React, { Component } from 'react';
import NavItem from './NavItem';

let $ = window.jQuery;

export default class Nav extends Component {
    state = {
        menu: [
            {
                label: 'Dashboard',
                icon: 'icon-home',
                link: '/home',
                permissions: ['appointments.*', 'appointments.view']
            },
            {
                label: 'Patients',
                icon: 'icon-users',
                link: '/patients',
                permissions: ['patients.*', 'patients.view']
            },
            {
                label: 'Clinic Management',
                icon: 'icon-folder',
                link: '/home',
                submenu: [
                    {
                        label: 'Clinic Management',
                        icon: 'icon-folder',
                        link: '/management',
                        permissions: ['clinic-management.view']
                    },
                    {
                        label: 'Accounting',
                        icon: 'icon-graph',
                        link: '/management/accounting',
                        permissions: ['accounting.view']
                    },
                    {
                        label: 'Procedure',
                        icon: 'icon-list',
                        link: '/management/procedures',
                        permissions: ['procedures.*', 'procedures.view']
                    },
                    {
                        label: 'Accounts',
                        icon: 'icon-bar-chart',
                        link: '/management/accounts',
                        permissions: ['accounts.*', 'accounts.view']
                    },
                    {
                        label: 'Clinics',
                        icon: 'icon-heart',
                        link: '/management/clinics',
                        permissions: ['clinics.*', 'clinics.view']
                    },
                    {
                        label: 'Inventory',
                        icon: 'icon-bar-chart',
                        link: '/management/inventory',
                        permissions: ['inventory.*', 'inventory.view']
                    },
                    {
                        label: 'Prescription Templates',
                        icon: 'fa fa-medkit',
                        link: '/management/prescriptions',
                        permissions: ['prescription-templates.*', 'prescription-templates.view']
                    },
                    {
                        label: 'SMS Manager',
                        icon: 'fa fa-envelope-o',
                        link: '/management/sms-manager',
                        permissions: ['sms-manager.*', 'sms-manager.view']
                    },
                    {
                        label: 'Application Settings',
                        icon: 'icon-settings',
                        link: '/management/settings',
                        permissions: ['settings.*', 'settings.view']
                    }
                ]
            }
        ],
        selectedMenu: 0
    };

    selectMenu = (index) => {
        this.setState({
            selectedMenu: index
        });
    };

    componentDidMount() {
        const i = this.state.menu.findIndex((item) => item.link === location.pathname);
        this.setState({
            selectedMenu: i
        });

        $('.nav-link').on('click', () => {
            $('.menu-toggler').click();
        })
    }

    render() {
        return (
            <div className="page-sidebar-wrapper">
                <div className="page-sidebar navbar-collapse collapse">
                    <ul className="page-sidebar-menu  page-header-fixed page-sidebar-menu-hover-submenu page-sidebar-menu-closed"
                        data-keep-expanded="false" data-auto-scroll="true" data-slide-speed="200">

                        {this.state.menu.map((item, i) => {
                            return <NavItem {...item} selectMenu={this.selectMenu}
                                            userPermissions={this.props.userPermissions}
                                            user={this.props.user}
                                            selectedItem={this.state.selectedMenu} key={i} index={i} />
                        })}
                    </ul>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Nav/Nav.js
 **/